import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import './index.css'
import { Link } from 'react-router-dom'
import ButtonPurple from 'components/design/Form/ButtonPurple'

const ModalAIFeatures = () => {
  const settings = useSelector(state => state.settings)
  const { featureLabel = '' } = settings
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const handleConfigure = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
    localStorage.removeItem('ccNavOpenKeys')
    localStorage.removeItem('ccNavSelectedKey')
    localStorage.setItem('ccNavOpenKeys', JSON.stringify(['chats']))
    localStorage.setItem('ccNavSelectedKey', JSON.stringify(['chat-settings']))
  }

  const { visibleModalID } = settings
  const modalID = 'aiFeatures'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="custom__success__modal"
      title={<div>AI Feature Requires AI Settings to Be Enabled</div>}
      onCancel={handleCancel}
      afterClose={handleCancel}
      open={visible}
      footer={null}
      maskClosable={false}
    >
      <div className="p-0 gap-4">
        <div className="mb-2">
          {' '}
          The {featureLabel} feature cannot be enabled until AI Settings are enabled. Please enable
          AI Settings first, then return to activate this feature.
        </div>
        <Link to="chat-settings">
          <ButtonPurple onClick={handleConfigure} buttonText="Configure AI Settings" />
        </Link>
      </div>
    </Modal>
  )
}

export default ModalAIFeatures
